import React, { useState, useRef, useEffect } from 'react';
import ReactMarkdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import { linkRenderer } from '@ynap/router';

const bem = new BEMHelper('HeaderNav');

const HeaderNav = (props) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { internal_urls = [], loading, locale, subCategoryLinks, urlConfig = {} } = props;

    const [showNextButton, setShowNextButton] = useState(false);
    const navRef = useRef();

    useEffect(() => {
        const { clientWidth, scrollWidth } = navRef.current;

        if (scrollWidth > clientWidth) {
            setShowNextButton(true);
        }
    }, []);

    const next = () => {
        setShowNextButton(false);
        navRef.current.scrollLeft = navRef.current.offsetWidth;
    };

    const components = { overrides: { a: ({ children, href }) => linkRenderer(urlConfig, internal_urls, locale, href, children) } };

    return (
        <nav
            className={bem('navList', { loading })}
            ref={navRef}
            onScroll={() => {
                showNextButton && setShowNextButton(false);
            }}
        >
            <ReactMarkdown
                className={bem('navItem')}
                options={{
                    forceBlock: true,
                    forceWrapper: true,
                    wrapper: 'div',
                    ...components,
                }}
            >
                {subCategoryLinks}
            </ReactMarkdown>

            {showNextButton && (
                <span className={bem('navItem')}>
                    <button aria-label="Next Sub Categories" className={bem('nextButton')} onClick={next} type="button" />
                </span>
            )}
        </nav>
    );
};

HeaderNav.propTypes = {
    subCategoryLinks: PropTypes.string.isRequired,
    loading: PropTypes.boolean,
    urlConfig: PropTypes.object,
    internal_urls: PropTypes.array,
    locale: PropTypes.string,
};

export default HeaderNav;
